import React, { FC, useEffect, useRef, useState } from "react";
import PreAuthAyushman from "../../../../components/patient/PreAuth/Ayushman Bharat/PreAuthAyushman";
import { Button, Form, Modal, Space, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import { IDocumentFields } from "../../../../interfaces/ICase";
import { IUploadReferral } from "../../../../interfaces/IReferral";
import {
  fetchStepperData,
  getVisitStageStates,
} from "../../../../models/preAuthSlice";
import {
  getPortalDataForAyushB,
  getProcedures,
} from "../../../../models/ayushmanBSlice";
import {
  deleteUploadedDocument,
  downloadDocument,
  fetchAllDocumentTypes,
  getAllStarhealthDocumentsData,
  submitApprovalAyushman,
  updateAllDocumentsData,
} from "../../../../apis/patientService";
import { message } from "antd";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/notificationUtils";
import {
  getBasicDetails,
  getDeficiencyQuestionData,
  getTimelineDetails,
} from "../../../../models/patientSlice";
import UploadRequestExtraDocumentAyushman, {
  DocumentMasterOption,
} from "../../../../components/patient/PreAuth/Ayushman Bharat/UploadRequestExtraDocumentAyushman";
import {
  CloudDownloadOutlined,
  DeleteOutlined,
  ExclamationOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { UploadDocument } from "../../../../models/EnhancementSlice";
import FilePreviewModal from "../../../../components/patient/PreAuth-query/FilePreviewModal";
import RightSidePreviewModal from "../../../../components/modals/RightSidePreviewModal";
import DocumentDeficiencyModal from "../../../../components/patient/DocumentDeficiencyModal";
import ManuallyClaimIdPortal from "../../../../components/patient/PreAuth/ManuallyClaimIdPortal";
import PortalSubmissionModal from "../../../../components/patient/PreAuth/PortalSubmissionModal";
import ManuallyIdModal from "../../../../components/patient/PreAuth/ManuallyIdModal";
import PortalSubmitModal from "../../../../components/patient/PreAuth/PortalSubmitModal";
import ConfirmSubmissionModalStage from "../../../../components/modals/ConfirmSubmissionModalStage";
import dayjs from "dayjs";
import { mapFormItemsToTreatmentPlansData, deriveOptionsFromTreatmentPlans, mapInvestigationsToDocTypes, mapImplantsToDocTypes } from "../../../../utils/ayushmanTreatmentPlanMapper";
import {
  postPreAuthToPortalAyushman,
  saveDraftAyushman,
  updateDraftAyushman,
} from "../../../../apis/ayushmanBService";
import Loader from "../../../../utils/Spinners";
import MultipleFilesPreviewModal from "../../../../components/patient/PreAuth-query/MultipleFilesPreviewModal";
import PatientDetailsStageDocument from "../../../../components/modals/PatientDetailsStageDocument";
import { errorMessageModal } from "../../../../utils/modalMessage";

type PreAuthAyushmanContainerProps = {
  activeKey: any;
  sseData?: any;
  sseUpdateCount?: any;
};

const modalBaseConfig = {
  centered: true,
  closable: false,
  maskClosable: false,
  width: 460,
  bodyStyle: { padding: "16px 12px 12px" },
  zIndex: 2500,
};

const containerStyle = {
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center",
  textAlign: "center" as const,
};

const iconWrapperStyle = (color: string) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 52,
  height: 52,
  borderRadius: "50%",
  border: `2px solid ${color}`,
  boxShadow: `0 0 12px ${color}66`,
  marginBottom: 16,
});

const titleStyle = {
  fontWeight: 700,
  fontSize: 18,
  marginBottom: 8,
  textTransform: "uppercase" as const,
};

const contentStyle = {
  fontSize: 16,
  fontWeight: 500,
  color: "#595959",
  marginBottom: 24,
};

const footerStyle = {
  display: "flex",
  justifyContent: "center",
  gap: 12,
};

const okButtonStyle = (color: string) => ({
  minWidth: 100,
  backgroundColor: color,
  borderColor: color,
  color: "#fff",
  fontWeight: 600,
});

interface DiagnosisData {
  diagnosis: string;
  // diagnosisId: string;
  diagnosisCode: string;
  type: string;
}

interface JsonObject {
  [key: string]: any;
}
interface TreatmentPlan {
  speciality: JsonObject;
  procedure: JsonObject;
  stratification: JsonObject;
  numberOfDaysPerUnits: number | null;
  ichiCode?: string | null;
  procedureRate?: string | number | null;
  quantityAllowed?: number | null;
}

interface Document {
  id: number;
  type?: string;
  file?: any;
  documentId?: any;
  label?: string;
  name?: string;
  labelId?: string | number;
  documentUniqueCode?: string;
  documentName?: string;
  requestDocument?: boolean;
  responseDocument?: boolean;
}

const warningMessageModal = (message: string): void => {
  Modal.confirm({
    ...modalBaseConfig,
    icon: null,
    content: (
      <div style={containerStyle}>
        <div style={iconWrapperStyle("#faad14")}>
          <ExclamationOutlined style={{ fontSize: 24, color: "#faad14" }} />
        </div>

        <div style={titleStyle}>WARNING</div>
        <div style={contentStyle}>{message}</div>
      </div>
    ),
    okText: "OK",
    footer: (_, { OkBtn }) => (
      <div style={footerStyle}>
        <OkBtn />
      </div>
    ),
    okButtonProps: {
      style: okButtonStyle("#faad14"),
    },
  });
};

const PreAuthAyushmanContainer: FC<PreAuthAyushmanContainerProps> = ({
  activeKey,
  sseData,
  sseUpdateCount,
}) => {
  const [form] = Form.useForm();
  const { patients, preAuth, preAuthClaim, enhancement, auth, ayushBPreAuth, hospital } =
    useSelector((state: RootState) => state);

  const currentActiveStage = preAuth?.stepperData?.visitStages?.find(
    (stage: any) =>
      stage?.visitStageId ===
      (typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]))
  );

  const isPreAuthTabActive = () => {
    if (!activeKey || activeKey.length === 0) return false;

    const currentStageId =
      typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]);

    const currentStage = preAuth?.stepperData?.visitStages?.find(
      (stage: any) => stage?.visitStageId === currentStageId
    );

    setIsErrorState(currentStage?.state?.toLowerCase() === "error");

    return currentStage?.visitStage?.toUpperCase() === "PREAUTH";
  };

  const dateFormat = "DD-MM-YYYY HH:mm:ss";

  const currentStageDetails = preAuth?.stepperData?.currentVisitStage;

  const [isApproved, setIsApproved] = useState<boolean>(false);
  const [isApprovedInitiated, setIsApprovedInitiated] =
    useState<boolean>(false);
  const [manuallyClaimIdPortal, setManuallyClaimIdPortal] =
    useState<boolean>(false);

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false); //for submit on portal
  const [isIntimating, setIsIntimating] = useState<boolean>(false); //for intimation of preauth button
  const [isSaving, setIsSaving] = useState<boolean>(false); //for saving and updating as draft

  const [
    documentRequestResponseDocuments,
    setDocumentRequestResponseDocuments,
  ] = useState<any>();

  const [activeStep, setActiveStep] = useState<number>(0);
  const [medcoDoctors, setMedcoDoctor] = useState<any>([]);
    const [govtHospitalList, setGovtHospitalList] = useState<any>([]);
    const [diagnosisList, setDiagnosisList] = useState<any>([]);
  const [uploadFileModal, setUploadFileModal] = useState<boolean>(false);
  const [previewDocument, setPreviewDocument] = useState<boolean>(false);
  const [previewDocumentNew, setPreviewDocumentNew] = useState<boolean>(false);
  const [documentUrl, setDocumentUrl] = useState<string>("");
  const [selectedDocumentType, setSelectedDocumentType] = useState<
    string | null
  >(null);
  const [fetchingDeficiencyData, setFetchingDeficiencyData] =
    useState<boolean>(false);
  const [documentTypeList, setDocumentTypeList] = useState<{
    [key: string]: Document[];
  }>({});
  const [formattedDocumentTypeList, setFormattedDocumentTypeList] = useState<{
    [key: string]: Document[];
  }>({});
  const [uploadedInvestigationFileList, setUploadedInvestigationFileList] =
    useState<IDocumentFields[]>([]);
  const [uploadedImplantFileList, setUploadedImplantFileList] = useState<
    IDocumentFields[]
  >([]);
  const [treatmentPlansData, setTreatmentPlansData] = useState<TreatmentPlan[]>(
    []
  );
  const [diagnosisData, setDiagnosisData] = useState<DiagnosisData[]>([]);

   const [isSubmittedOnPortal, setIsSubmittedOnPortal] =
      useState<boolean>(false);
      const [isManuallyEnteredId, setIsManuallyEnteredId] = useState(false); //open enter id manually
        const [submissionModal, setSubmissionModal] = useState<boolean>(false);
        const [isLoading, setIsLoading] = useState<boolean>(false); // to check whether submitting api is going or not so that we can show loader acc. to that
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState<string>("");
  const [documentName, setDocumentName] = useState<string>("");
  const [stageStatus, setStageStatus] = useState<number | null>(null);
  const [deficiencyModal, setDeficiencyModal] = useState<boolean>(false);

  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [extraRequestModalOpen, setExtraRequestModalOpen] =
    useState<boolean>(false);
  const [documentMasterOptions, setDocumentMasterOptions] = useState<
    DocumentMasterOption[]
  >([]);
  const [activeDocListType, setActiveDocListType] = useState<string>("");
  const [claimId, setClaimId] = useState("");
  const [selectedFile, setSelectedFile] = useState<{
    file: any;
    documentType: string;
  } | null>(null);
  const [pendingDocUploadMeta, setPendingDocUploadMeta] = useState<{
    documentMasterName?: string;
    implantQuantity?: number;
    labelId?: string | number;
    documentUniqueCode?: string;
  } | null>(null);

  const [previewFile, setPreviewFile] = useState<{
    url: string;
    name: string;
    showUpload: boolean;
    documentType: string;
  }>({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });

  const dispatch = useDispatch<AppDispatch>();
  const [documentTypes, setDocumentTypes] = useState<Document[]>([]);
  const [documentUrls, setDocumentUrls] = useState<
    {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType: string | null;
      documentLabelType: any;
      deficiencyCheckStatus: any;
      remarks: string | null;
    }[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);

  const schemeMetaDataId =
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;
  const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
  const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

  const fetchDocuments = async () => {
    if (schemeMetaDataId && caseId && visitId) {
      try {
        setLoading(true);
        const AllDocumentList = await getAllStarhealthDocumentsData(
          caseId,
          visitId,
          schemeMetaDataId
        );

        setDocumentTypes(AllDocumentList?.["PreAuth"]);
      } catch (err) {
        // errorMessage("Please, Try again after sometime");
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const requestResponseDocuments = {
      requestedDocuments: [] as Document[],
      responseDocuments: [] as Document[],
    };

    documentTypes?.forEach((document) => {
      if (document?.requestDocument || true) {
        requestResponseDocuments.requestedDocuments.push(document);
      } else if (document?.responseDocument) {
        requestResponseDocuments.responseDocuments.push(document);
      }
    });

    setDocumentRequestResponseDocuments(requestResponseDocuments);
  }, [documentTypes]);

  useEffect(() => {
    const documentList = [
      ...documentTypes
        ?.filter(
          (item: any) => item.documentList && item.documentList.length > 0
        )
        ?.flatMap((item: any, index: number) =>
          item.documentList!?.map((doc: any, docIndex: any) => ({
            key: `${index + 1}`,
            label: item.label, // Document Type
            documentUrl: doc.documentUrl, // URL for download
            id: doc.id,
            documentType: doc.documentType,
            documentName: doc.documentName,
            deficiencyCheckStatus:
              doc.deficiencyCheckStatus === true
                ? true
                : doc.deficiencyCheckStatus === false
                ? false
                : null,
            deficiency:
              doc.deficiencyCheckStatus === true
                ? true
                : doc.deficiencyCheckStatus === false
                ? false
                : null,
            remarks: doc.remarks || null,
            documentLabelType: doc.documentLabelType,
            documentMasterName: doc.documentMasterName ?? null,
            actions: item,
          }))
        ),
    ];

    setDocumentUrls(documentList);
  }, [documentTypes]);

  const fetchDocumentMasterTypes = async () => {
    try {
      const response = await fetchAllDocumentTypes();
      const allDocumentList = Array.isArray(response)
        ? response
        : Array.isArray(response?.data)
          ? response.data
          : [];

      setDocumentMasterOptions(
        allDocumentList.map((item: any) => ({
          id: item?.id,
          label: item?.documentName,
          labelId: item?.id,
          documentUniqueCode: item?.uniqueKey ?? "",
        }))
      );
    } catch (err) {
      errorMessage("Please, Try again after sometime");
    }
  };

  useEffect(() => {
      if (
        ayushBPreAuth?.portalData?.portalRegistrationStatus?.toUpperCase() ===
        "DISCREPANCY"
      ) {
        warningMessageModal("There is Mismatch in Registration Details");
      }
    }, [ayushBPreAuth?.portalData?.portalRegistrationStatus]);

  useEffect(() => {
    setIsApproved(
      ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.casePreAuthResponse
        ?.approved
    );
  }, [
    ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.casePreAuthResponse
      ?.approved,
  ]);

  // Keep all investigation/implant types available so multiple files
  // can be uploaded for the same type. Delete removes a single file only.
  useEffect(() => {
    if (documentTypeList?.implant) {
      setFormattedDocumentTypeList((prev) => ({
        ...prev,
        ["implant"]: documentTypeList?.implant || [],
      }));
    }
  }, [documentTypeList?.implant]);

  useEffect(() => {
    if (documentTypeList?.investigation) {
      setFormattedDocumentTypeList((prev) => ({
        ...prev,
        ["investigation"]: documentTypeList?.investigation || [],
      }));
    }
  }, [documentTypeList?.investigation]);

  const fetchStepperForStatus = async () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      dispatch(fetchStepperData({ caseId: caseId, visitId: visitId }));
    }
  };

  useEffect(() => {
    if (
      currentActiveStage?.visitStageId &&
      activeKey &&
      activeKey?.length > 0 && isPreAuthTabActive()
    ) {
      dispatch(
        getVisitStageStates({ visitStageId: currentActiveStage?.visitStageId })
      );
    }
  }, [currentActiveStage?.visitStageId, ayushBPreAuth?.portalData, activeKey]);

  const handleGetData = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      dispatch(
        getPortalDataForAyushB({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
      // fetchStepperForStatus();
    }
  };

  useEffect(() => {
    setDocumentTypeList((prev) => ({
      ...prev,
      implant: [],
    }));
  }, []);

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;
    let timeoutId: NodeJS.Timeout | null = null;
    let pollCount = 0;
    const maxPolls = 24;
    const modifiedAt = ayushBPreAuth?.portalData?.modifiedAt;

    const modifiedTime = new Date(modifiedAt).getTime();
    const now = Date.now();
    const diffSeconds = (now - modifiedTime) / 1000;

    if (
      ayushBPreAuth?.portalData?.stateName === "Initiated" &&
      ayushBPreAuth?.portalData?.visitStagesName?.toLowerCase() === "preauth" &&
      !ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId &&
      diffSeconds <= 78
    ) {
      intervalId = setInterval(() => {
        pollCount++;
        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        ) {
          dispatch(
            getPortalDataForAyushB({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
        }

        if (ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId) {
          if (intervalId) clearInterval(intervalId);
          if (timeoutId) clearTimeout(timeoutId);
        }

        if (pollCount >= maxPolls) {
          if (intervalId) clearInterval(intervalId);
          // setShowManualClaimIdModal(true);
        }
      }, 5000);

      timeoutId = setTimeout(() => {
        if (intervalId) clearInterval(intervalId);
        // setShowManualClaimIdModal(true);
      }, 120000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [
    ayushBPreAuth?.portalData?.stateName,
    ayushBPreAuth?.portalData?.visitStagesName,
    ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  const [isFetchingProcedure, setIsFetchingProcedure] =
    useState<boolean>(false);

  const handleDropdownData = async () => {
    if (patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0] && patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      const payload = {
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: schemeMetaDataId,
      };
      setIsFetchingProcedure(true);
      await dispatch(
        getProcedures({
          payload: payload,
        })
      );
      setIsFetchingProcedure(false);
    }
  };

  const getAttachmentsWithValues = (attchmentData: any, key: string) => {
    const attachmentsWithValues: IDocumentFields[] = [];
    if (attchmentData) {
      if (key == "investigation")
        setUploadedInvestigationFileList(attchmentData);
      if (key == "implant") setUploadedImplantFileList(attchmentData);
    }
  };

  const fetchDataForSse = async () => {
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      // dispatch(
      //   getBasicDetails({
      //     id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
      //   })
      // );

      dispatch(
        getPortalDataForAyushB({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
    }
    fetchStepperForStatus();
    await getTimelineDetail();
    fetchDocuments();
  };

  useEffect(() => {
    if (sseData) {
      fetchDataForSse();
    }
  }, [sseData, sseUpdateCount]);

  const handleFileChange =
    (documentType: string, docLabel: string | null = null) =>
    (e: any) => {
      const maxSize = 15 * 1024 * 1024;
      if (Array.isArray(e)) {
        return e;
      }
      if (e?.fileList[0]) {
        setSelectedFile({ file: e?.fileList[0], documentType });
        setPreviewFile({
          url: URL.createObjectURL(e?.file),
          name: e.file.name,
          showUpload: true,
          documentType: documentType,
        });
        setUploadFileModal(true);
      }
      return e?.fileList;
    };

  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; documentType: string }[]
  >([]);
  const [previewFiles, setPreviewFiles] = useState<
    {
      url: string;
      name: string;
      showUpload: boolean;
      documentType: string;
      isMultiple: boolean;
    }[]
  >([]);
  const [uploadFileList, setUploadFileList] = useState<any[]>([]);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [clickedActiveDocumentUrl, setClickedActiveDocumentUrl] =
    useState<any>();

  useEffect(() => {
    if (!previewModalVisible) {
      setSelectedFiles([]);
    }
  }, [previewModalVisible]);

  const [isErrorState, setIsErrorState] = useState<boolean>(false);
      const lastErrorMessageRef = useRef<string | null>(null);
    
      useEffect(() => {
        if (isPreAuthTabActive()) {
          lastErrorMessageRef.current = null;
        }
      }, [activeKey]);

      useEffect(() => {
        if (
          isErrorState &&
          ayushBPreAuth?.portalData?.claimIdGenerationErrorMessage &&
          ayushBPreAuth?.portalData?.claimIdGenerationErrorMessage !==
            lastErrorMessageRef.current && isPreAuthTabActive()
        ) {
          errorMessageModal(ayushBPreAuth?.portalData?.claimIdGenerationErrorMessage);
          lastErrorMessageRef.current =
            ayushBPreAuth?.portalData?.claimIdGenerationErrorMessage;
        }
      }, [ayushBPreAuth?.portalData, isErrorState, activeKey]);

  const handleFileChangeNew =
    (documentType: string, isMultiple: boolean) => (e: any) => {
      if (isMultiple) {
        const files = e?.fileList || [];
        setUploadFileList(files);
        if (files.length === 0) return;

        const selected = files?.map((f: any) => ({
          file: f.originFileObj,
          documentType,
        }));

        const previews = files?.map((f: any) => ({
          url: URL.createObjectURL(f.originFileObj),
          name: f.name,
          showUpload: true,
          documentType,
          isMultiple: isMultiple,
        }));

        setSelectedFiles(selected);
        setPreviewFiles(previews);
        setPreviewModalVisible(true);
      } else {
        if (Array.isArray(e)) {
          return e;
        }
        if (e?.file) {
          setSelectedFile({ file: e.file, documentType: documentType });
          setPreviewFile({
            url: URL.createObjectURL(e.file),
            name: e.file.name,
            showUpload: true,
            documentType: documentType,
          });
          setPreviewModalVisible(true);
        }
        return e?.target?.files;
      }
    };

  const handleOpenNew = (docType: any, documentUrl: any) => {
    setPreviewDocument(true);
    setClickedActiveTab(docType);
    setClickedActiveDocumentUrl(documentUrl);
  };

  const handleCancelPreviewNew = () => {
    setPreviewDocument(false);
    setPreviewDocumentUrl("");
    setDocumentName("");
  };

  const validateRequiredDocuments = (
    mandatoryDocuments: any,
    documentUrls: any
  ) => {
    for (const doc of mandatoryDocuments) {
      if (doc.required && doc.visible) {
        const isUploaded = documentUrls?.some(
          (uploadedDoc: any) => uploadedDoc.documentLabelType === doc.label
        );
        if (!isUploaded) {
          return false;
        }
      }
    }
    return true;
  };

  const handleUploadDocument = async () => {
    const CollectPostData = new FormData();
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id.toString()
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
      );
    }

    if (pendingDocUploadMeta?.documentMasterName) {
      CollectPostData.append(
        "documentMasterName",
        pendingDocUploadMeta.documentMasterName
      );
    } else if (previewFile.documentType) {
      CollectPostData.append("documentType", previewFile.documentType);
    }

    if (activeDocListType === "implant") {
      CollectPostData.append(
        "implantQuantity",
        String(pendingDocUploadMeta?.implantQuantity || 1)
      );
    }

    const fileBlob =
      selectedFile?.file?.originFileObj || selectedFile?.file;
    if (fileBlob) {
      CollectPostData.append("file", fileBlob as Blob);
    }

    try {
      const resp = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        })
      );

      if (UploadDocument.fulfilled.match(resp)) {
        const documentList =
          activeDocListType == "investigation"
            ? uploadedInvestigationFileList
            : uploadedImplantFileList;
        const stampedPayload = (resp?.payload || []).map((doc: any) => ({
          ...doc,
          documentType:
            doc?.documentType ||
            pendingDocUploadMeta?.labelId ||
            previewFile.documentType,
          documentUniqueCode:
            doc?.documentUniqueCode || pendingDocUploadMeta?.documentUniqueCode,
          documentMasterName:
            doc?.documentMasterName || pendingDocUploadMeta?.documentMasterName,
          ...(activeDocListType === "implant"
            ? {
                implantQuantity:
                  pendingDocUploadMeta?.implantQuantity ||
                  doc?.implantQuantity ||
                  1,
              }
            : {}),
        }));
        const updatedDocuments = [...stampedPayload, ...documentList];
        if (stampedPayload?.length > 0) {
          message.success(
            `${stampedPayload?.[0]?.documentLabelType || pendingDocUploadMeta?.documentMasterName || "Document"} uploaded successfully`
          );
          if (activeDocListType == "investigation")
            setUploadedInvestigationFileList(updatedDocuments);
          if (activeDocListType == "implant")
            setUploadedImplantFileList(updatedDocuments);
        } else {
          message.error("Please Upload Again");
        }
        setUploadFileModal(false);
        setPendingDocUploadMeta(null);
      } else if (UploadDocument.rejected.match(resp)) {
        errorMessage("FAILED TO UPLOAD DOCUMENT");
      }
    } catch (error) {
      console.error("Failed to upload document:", error);
    }
  };

  const handleImplantRowUpload = (
    implantOption: any,
    quantity: number,
    file: File
  ) => {
    const labelId = implantOption?.labelId ?? implantOption?.id;
    const documentMasterName =
      implantOption?.name ||
      implantOption?.label ||
      implantOption?.documentMasterName ||
      "";
    setActiveDocListType("implant");
    setPendingDocUploadMeta({
      documentMasterName,
      implantQuantity: quantity || 1,
      labelId,
      documentUniqueCode: implantOption?.documentUniqueCode,
    });
    setSelectedFile({
      file,
      documentType: String(labelId ?? ""),
    });
    setPreviewFile({
      url: URL.createObjectURL(file),
      name: file.name,
      showUpload: true,
      documentType: String(labelId ?? ""),
    });
    setUploadFileModal(true);
  };

  const handleInvestigationRowUpload = (
    investigationOption: any,
    file: File
  ) => {
    const labelId = investigationOption?.labelId ?? investigationOption?.id;
    const documentMasterName =
      investigationOption?.name ||
      investigationOption?.label ||
      investigationOption?.documentMasterName ||
      "";
    setActiveDocListType("investigation");
    setPendingDocUploadMeta({
      documentMasterName,
      labelId,
      documentUniqueCode: investigationOption?.documentUniqueCode,
    });
    setSelectedFile({
      file,
      documentType: String(labelId ?? ""),
    });
    setPreviewFile({
      url: URL.createObjectURL(file),
      name: file.name,
      showUpload: true,
      documentType: String(labelId ?? ""),
    });
    setUploadFileModal(true);
  };

  const handlePreviewUploadedDoc = (documentUrl: string) => {
    if (!documentUrl) return;
    setDocumentUrl(documentUrl);
    setPreviewDocumentNew(true);
  };

  const handleModalOpen = React.useCallback((listType: any) => {
    if (listType === "extraRequest") {
      fetchDocumentMasterTypes();
      setExtraRequestModalOpen(true);
    }
  }, []);

  const handleExtraRequestModalClose = React.useCallback(
    () => setExtraRequestModalOpen(false),
    []
  );

  const handleExtraRequestUploadAttached = async (
    uploadResponse: any[],
    meta: {
      selectedMasterId: string | null;
      documentMasterName: string | null;
    }
  ) => {
    const casesResponse = patients?.fetchBasicDetails?.casesResponse;
    const visitInfo = patients?.fetchBasicDetails?.visitInfoResponse;
    const patientResponse = patients?.fetchBasicDetails?.patientResponse;

    const attachments = uploadResponse.map((doc: any) => ({
      ...doc,
      hospitalId: casesResponse?.healthCareId?.toString(),
      caseId: casesResponse?.id?.toString(),
      visitId: visitInfo?.id,
      schemeMetaDataId: casesResponse?.schemeMetaDataId,
      patientId: patientResponse?.id?.toString(),
      ...(meta.documentMasterName
        ? {
            documentMasterName: meta.documentMasterName.toLowerCase(),
            documentType: null,
            documentLabelType: meta.documentMasterName.toLowerCase(),
          }
        : {}),
    }));

    await handleAttachDocuments(attachments);
  };

  const handleCancel = React.useCallback(() => {
    setUploadFileModal(false);
    setPendingDocUploadMeta(null);
  }, []);

  const handleCancelPreview = React.useCallback(() =>  setPreviewDocumentNew(false), []);

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
    } catch (err: any) {
      errorMessage("Please, Try again later");
    }
  };

  const handleDeleteDocument = async (
    docType: string,
    documentUrl: string,
    activeDocListType: any
  ) => {
    let deleteDocument;
    if (activeDocListType == "investigation") {
      deleteDocument = uploadedInvestigationFileList?.find(
        (doc, index) => doc?.documentUrl === documentUrl
      );
    }
    if (activeDocListType == "implant") {
      deleteDocument = uploadedImplantFileList?.find(
        (doc, index) => doc?.documentUrl === documentUrl
      );
    }

    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };

    let newUpdatedDocumentList;
    if (activeDocListType == "investigation") {
      newUpdatedDocumentList = uploadedInvestigationFileList?.filter(
        (doc, index) => doc?.documentUrl !== documentUrl
      );
    }
    if (activeDocListType == "implant") {
      newUpdatedDocumentList = uploadedImplantFileList?.filter(
        (doc, index) => doc?.documentUrl !== documentUrl
      );
    }
    // dispatch(setUploadedDocumentUrl(newUpdatedDocumentList));
    if (deleteDocument?.documentUrl) {
      const res = await deleteUploadedDocument(deleteForm);
      if (res) {
        // message.success("Document Deleted Successfully!");
        if (activeDocListType == "investigation")
          setUploadedInvestigationFileList(newUpdatedDocumentList || []);
        if (activeDocListType == "implant")
          setUploadedImplantFileList(newUpdatedDocumentList || []);
      }
    }
  };

  const handleDeleteImplantDoc = (
    documentType: string,
    documentUrl: string
  ) => {
    return handleDeleteDocument(documentType, documentUrl, "implant");
  };

  const handleDeleteInvestigationDoc = (
    documentType: string,
    documentUrl: string
  ) => {
    return handleDeleteDocument(documentType, documentUrl, "investigation");
  };

  const handleUpload = async () => {
    if (selectedFiles?.length > 0) {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
        );
      }
      CollectPostData.append("documentType", previewFiles?.[0]?.documentType);

      selectedFiles?.map((fileObj, index) =>
        CollectPostData.append(`file${index}`, fileObj.file)
      );

      // if (selectedFiles?.length > 0) {
      //   selectedFiles.forEach((fileObj, index) => {
      //     // Extract the actual File object from your structure
      //     const actualFile = fileObj.file; // This is the originFileObj (actual File)

      //     if (actualFile instanceof File) {
      //       CollectPostData.append("files", actualFile);
      //     }
      //   });
      // }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          })
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`
        );
        await handleAttachDocuments(documentRes);
        setSelectedFiles([]);
        setPreviewFiles([]);
        setUploadFileList([]);
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    } else {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
        );
      }
      CollectPostData.append("documentType", previewFile.documentType);

      if (selectedFile?.file) {
        CollectPostData.append("file", selectedFile?.file);
      }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          })
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`
        );
        await handleAttachDocuments(documentRes);
        setSelectedFile(null);
        setPreviewFile({
          url: "",
          name: "",
          showUpload: false,
          documentType: "",
        });
      } catch (error) {
        console.error("Failed to upload document:", error);
      }
    }
  };

  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number
  ) => {
    const investigationDoc = (uploadedInvestigationFileList || []).find(
      (doc) => doc?.documentUrl === documentUrl
    );
    if (investigationDoc?.documentUrl) {
      await handleDeleteDocument(
        String(investigationDoc?.documentType || documentType),
        documentUrl,
        "investigation"
      );
      return;
    }

    const combinedUrls = [...documentUrls];
    const deleteDocument = combinedUrls.find(
      (doc) => doc.documentUrl === documentUrl
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };

    const newUpdatedDocumentList = combinedUrls.filter(
      (doc) => doc.documentUrl !== documentUrl
    );
    setDocumentUrls(newUpdatedDocumentList);

    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
      } catch (error) {
        // errorMessage("Failed to delete document");
      }
    }
  };

  const handleSetDocumentUrl = (url: string) => setDocumentUrl(url);
  const handleOpen = () => setPreviewDocumentNew(true);

  useEffect(() => {
    if(activeKey && activeKey?.length > 0 && isPreAuthTabActive()) {
    handleGetData();
    fetchDocuments();
    }
  }, [patients?.fetchBasicDetails?.visitInfoResponse?.id]);

  useEffect(() => {
    if(activeKey && activeKey?.length > 0 && isPreAuthTabActive()) handleDropdownData();
  }, [patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId, activeKey]);

  useEffect(() => {
    if (ayushBPreAuth?.portalData?.casePreAuthOthersResponse) {
      if (
        ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.investigationList
      )
        getAttachmentsWithValues(
          ayushBPreAuth?.portalData?.casePreAuthOthersResponse
            ?.investigationList,
          "investigation"
        );
      if (ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.implantList)
        getAttachmentsWithValues(
          ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.implantList,
          "implant"
        );

      setClaimId(
        ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.claimId || ""
      );
    }
  }, [ayushBPreAuth?.portalData?.casePreAuthOthersResponse]);

  useEffect(() => {
    const savedPlans =
      ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.treatmentPlansData;
    if (savedPlans?.length) {
      setTreatmentPlansData(savedPlans);
    }
  }, [
    ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.treatmentPlansData,
  ]);

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any
  ) => {
    try {
      if (selectedDocumentId) {
        // dispatch(clearDeficiencyCheck());
        // const firstRes = await dispatch(
        //   getDeficiencyQuestions(selectedDocumentId)
        // );
        setFetchingDeficiencyData(true);
        const secondRes = await dispatch(
          getDeficiencyQuestionData(selectedDocumentId)
        );
        setFetchingDeficiencyData(false);
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
      setFetchingDeficiencyData(false);
    }
  };

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields
  ) => {
    await fetchDeficiencyData(document, documentId);
    setPreviewDocumentUrl(documentUrl);
    // setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDeficiencyModalOpenNew = async (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields
  ) => {
    await fetchDeficiencyData(document, document?.id);
    setPreviewDocumentUrl(documentUrl);
    // setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocument(null);
    setDocumentName("");
  };

  const resolveDocTypeDisplay = (
    record: IDocumentFields,
    listKey: "investigation" | "implant"
  ) => {
    const matched = documentTypeList?.[listKey]?.find(
      (item) =>
        String(item?.labelId) === String(record?.documentType) ||
        String(item?.id) === String(record?.documentType) ||
        String(item?.documentUniqueCode) === String(record?.documentType)
    );
    const name =
      record?.documentMasterName ||
      record?.documentLabelType ||
      matched?.name ||
      matched?.label ||
      "";
    const code = matched?.documentUniqueCode || "";
    if (name && code && !String(name).includes(String(code))) {
      return `${name} (${code})`;
    }
    return name || code || "-";
  };

  const uploadedFileColumns = React.useMemo(() => [
    {
      title: "S.No.",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: 80,
      render: (text: any, records: any, index: number) => (
        <span style={{ fontWeight: "bold" }}>{index + 1}</span>
      ),
    },
    {
      title: "Document Type",
      dataIndex: "documentLabelType",
      key: "documentLabelType",
      align: "center",
      render: (_text: string, record: IDocumentFields) => (
        <div style={{ textTransform: "initial", fontSize: "15px" }}>
          {resolveDocTypeDisplay(record, "investigation")}
        </div>
      ),
    },
    {
      title: "Document Name",
      dataIndex: "documentName",
      key: "document",
      align: "center",
      render: (text: string) => (
        <div style={{ textTransform: "initial", fontSize: "15px" }}>{text}</div>
      ),
    },
    // {
    //   title: "Deficiency Status",
    //   dataIndex: "deficiencyCheckStatus",
    //   key: "deficiency",
    //   align: "center",
    //   render: (text: boolean | null, record: IDocumentFields) => {
    //     return text === true ? (
    //       <Tag color="green">Pass</Tag>
    //     ) : text === false ? (
    //       <Tag color="red">Fail</Tag>
    //     ) : text === null || text === undefined ? (
    //       auth?.role?.role !== "FO_STAFF" ? (
    //         <Button
    //           style={{
    //             backgroundColor: "#E0E0E0",
    //             borderRadius: "10px",
    //             color: "#222222",
    //             boxShadow: "0px -1px 4px 0px #00000040 inset",
    //           }}
    //           type="primary"
    //           onClick={() => {
    //             if (record?.documentName) {
    //               setDocumentName(record.documentName);
    //             }
    //             if (record?.documentType) {
    //               record?.documentUrl &&
    //                 record?.id &&
    //                 record &&
    //                 handleDeficiencyModalOpen(
    //                   record?.documentUrl,
    //                   record?.id,
    //                   record
    //                 );
    //             }
    //           }}
    //         >
    //           <span style={{ textTransform: "initial" }}>Check Deficiency</span>
    //         </Button>
    //       ) : (
    //         <></>
    //       )
    //     ) : null;
    //   },
    // },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_: any, record: IDocumentFields) => (
        <Space size="middle">
          <EyeOutlined
            style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
            onClick={() => {
              handleOpen();
              record?.documentUrl && handleSetDocumentUrl(record?.documentUrl);
            }}
          />
          {/* <EditOutlined style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }} /> */}
          <CloudDownloadOutlined
            style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
            onClick={() =>
              record?.documentName &&
              record?.documentUrl &&
              handleDownloadDocument(record?.documentName, record?.documentUrl)
            }
          />
          <Button
            icon={
              <DeleteOutlined
                style={{
                  color: "#008B8B",
                  fontSize: "17px",
                  cursor: "pointer",
                }}
                disabled={
                  ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.submitted
                }
              />
            }
            onClick={() =>
              record?.documentType &&
              record?.documentUrl &&
              handleDeleteDocument(
                record?.documentType,
                record?.documentUrl,
                "investigation"
              )
            }
            disabled={
              ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                ?.casePreAuthResponse?.submitted
            }
          />
        </Space>
      ),
    },
  ], [documentTypeList?.investigation]);

  const uploadedImplantFileColumns = [
    {
      title: "S.No.",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: 80,
      render: (text: any, records: any, index: number) => (
        <span style={{ fontWeight: "bold" }}>{index + 1}</span>
      ),
    },
    {
      title: "Document Type",
      dataIndex: "documentLabelType",
      key: "documentLabelType",
      align: "center",
      render: (_text: string, record: IDocumentFields) => (
        <div style={{ textTransform: "initial", fontSize: "15px" }}>
          {resolveDocTypeDisplay(record, "implant")}
        </div>
      ),
    },
    {
      title: "Document Name",
      dataIndex: "documentName",
      key: "document",
      align: "center",
      render: (text: string) => (
        <div style={{ textTransform: "initial", fontSize: "15px" }}>{text}</div>
      ),
    },
    // {
    //   title: "Deficiency Status",
    //   dataIndex: "deficiencyCheckStatus",
    //   key: "deficiency",
    //   align: "center",
    //   render: (text: boolean | null, record: IDocumentFields) => {
    //     return text === true ? (
    //       <Tag color="green">Pass</Tag>
    //     ) : text === false ? (
    //       <Tag color="red">Fail</Tag>
    //     ) : text === null || text === undefined ? (
    //       auth?.role?.role !== "FO_STAFF" ? (
    //         <Button
    //           style={{
    //             backgroundColor: "#E0E0E0",
    //             borderRadius: "10px",
    //             color: "#222222",
    //             boxShadow: "0px -1px 4px 0px #00000040 inset",
    //           }}
    //           type="primary"
    //           onClick={() => {
    //             if (record?.documentName) {
    //               setDocumentName(record.documentName);
    //             }
    //             if (record?.documentType) {
    //               record?.documentUrl &&
    //                 record?.id &&
    //                 record &&
    //                 handleDeficiencyModalOpen(
    //                   record?.documentUrl,
    //                   record?.id,
    //                   record
    //                 );
    //             }
    //           }}
    //         >
    //           <span style={{ textTransform: "initial" }}>Check Deficiency</span>
    //         </Button>
    //       ) : (
    //         <></>
    //       )
    //     ) : null;
    //   },
    // },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_: any, record: IDocumentFields) => (
        <Space size="middle">
          <EyeOutlined
            style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
            onClick={() => {
              handleOpen();
              record?.documentUrl && handleSetDocumentUrl(record?.documentUrl);
            }}
          />
          {/* <EditOutlined style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }} /> */}
          <CloudDownloadOutlined
            style={{ color: "#008B8B", fontSize: "17px", cursor: "pointer" }}
            onClick={() =>
              record?.documentName &&
              record?.documentUrl &&
              handleDownloadDocument(record?.documentName, record?.documentUrl)
            }
          />
          <Button
            icon={
              <DeleteOutlined
                style={{
                  color: "#008B8B",
                  fontSize: "17px",
                  cursor: "pointer",
                }}
                disabled={
                  ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                    ?.casePreAuthResponse?.submitted
                }
              />
            }
            onClick={() =>
              record?.documentType &&
              record?.documentUrl &&
              handleDeleteDocument(
                record?.documentType,
                record?.documentUrl,
                "implant"
              )
            }
            disabled={
              ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                ?.casePreAuthResponse?.submitted
            }
          />
        </Space>
      ),
    },
  ];

  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [title, setTitle] = useState<string>("");
  const [confirmationState, setConfirmationState] = useState<string>("");

  const handleSaveConfirmationModal = async (confirmationState: string) => {
    if (confirmationState === "intimate") {
      try {
        if (auth?.role?.role !== "FO_STAFF") {
          await form.validateFields();
        } else {
          // FO: only General Findings are mandatory on Send To QC
          await form.validateFields([
            "temperature",
            "pulseRatePerMinute",
            "height",
            "weight",
            "allergies",
            "habitsAddictions",
          ]);
        }
      } catch (err: any) {
        if (err?.errorFields) {
          errorMessage("Please, Fill details before submitting");
        } else {
          errorMessage("Please, Try again later");
        }
        return;
      }
      if (
        !validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls,
        )
      ) {
        errorMessage("Please, Upload all required documents");
        return;
      }
    }

    setConfirmationModal(true);
    setConfirmationState(confirmationState);

    if (confirmationState === "save") {
      setTitle("Do You want to save PreAuth ?");
    } else if (confirmationState === "update") {
      setTitle("Do You want to update PreAuth ?");
    } else if (confirmationState === "intimate") {
      setTitle("Do you want to send PreAuth for QC ?");
    } else if (confirmationState === "submit") {
      setTitle("Do You want to submit PreAuth ?");
    } else if (confirmationState === "approve") {
      setTitle("Do You want to approve PreAuth ?");
    }
  };

  const handleSave = async () => {
    if (confirmationState === "save") {
      await handleSaveAsDraft();
    } else if (confirmationState === "update") {
      await handleUpdateAsDraft();
    } else if (confirmationState === "intimate") {
      await handleIntimateAyushman();
    } else if (confirmationState === "approve") {
      await handleApprovePreAuth();
    } else if (confirmationState === "submit") {
      await handleSaveManually();
    }

    setConfirmationModal(false);
  };

  // Derive investigation/implant doc types from nested procedure data
  // whenever treatment plans change (add/remove) or Get Data / portal restore.
  useEffect(() => {
    const proceduresRaw: any = ayushBPreAuth?.preAuth?.procedures;
    const procedures: any[] = Array.isArray(proceduresRaw)
      ? proceduresRaw
      : Array.isArray(proceduresRaw?.data)
        ? proceduresRaw?.data
        : Array.isArray(proceduresRaw?.content)
          ? proceduresRaw?.content
          : [];
    if (!treatmentPlansData?.length || !procedures?.length) {
      setDocumentTypeList((prev) => ({
        ...prev,
        investigation: [],
        implant: [],
      }));
      return;
    }

    const { investigations, implants } = deriveOptionsFromTreatmentPlans(
      treatmentPlansData,
      procedures,
    );

    setDocumentTypeList((prev) => ({
      ...prev,
      investigation: mapInvestigationsToDocTypes(investigations || []),
      implant: mapImplantsToDocTypes(implants || []),
    }));
  }, [treatmentPlansData, ayushBPreAuth?.preAuth?.procedures]);

  const buildCasePreAuthOthersRequest = (
    values: Record<string, any>,
    extra: Record<string, any> = {},
  ) => ({
    ...values,
    surgeryDate: values.surgeryDate
      ? dayjs(values.surgeryDate).format(dateFormat)
      : null,
    admissionDate: values.admissionDate
      ? dayjs(values.admissionDate).format(dateFormat)
      : null,
    incidentDate: values.incidentDate
      ? dayjs(values.incidentDate).format(dateFormat)
      : null,
    firDate: values.firDate ? dayjs(values.firDate).format(dateFormat) : null,
    treatmentPlansData:
      treatmentPlansData?.length > 0
        ? treatmentPlansData
        : mapFormItemsToTreatmentPlansData(values?.items, dateFormat),
    diagnosisData,
    investigationList: uploadedInvestigationFileList || [],
    implantList: uploadedImplantFileList || [],
    hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
    schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
    ...extra,
  });

  const handleSaveAsDraft = async () => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue(true);

      const updatedValues = buildCasePreAuthOthersRequest(values);

      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const payload = {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          beneficiaryId: values?.beneficiaryId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
          casePreAuthId: ayushBPreAuth?.portalData?.casePreAuthOthersResponse
            ?.casePreAuthResponse?.id
            ? ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                ?.casePreAuthResponse?.id
            : 0,
          casePreAuthIhxRequest: null,
          casePreAuthCghsRequest: null,
          casePreAuthVidalRequest: null,
          casePreAuthStarhealthRequest: null,
          casePreAuthEchsRequest: null,
          casePreAuthOthersRequest: updatedValues,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          totalAmount: "",
          claimOnPortal: true,
          action: "save",
        };
        setIsSaving(true);
        const resp = await saveDraftAyushman(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          payload
        );
        successMessage("PreAuth Saved Successfully");
        setConfirmationModal(false);
        setIsSaving(false);
        if (resp) {
          dispatch(
            getPortalDataForAyushB({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
          await getTimelineDetail();
          await fetchStepperForStatus();
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
        }
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessageModal("Please, Fill details before submitting");
      } else {
        console.error(err);
        errorMessageModal("Please, Try again later");
      }
      setIsSaving(false);
    }
  };

  const handleUpdateAsDraft = async () => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue(true);

      const updatedValues = buildCasePreAuthOthersRequest(values);

      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const payload = {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          beneficiaryId: values?.beneficiaryId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
          casePreAuthId: ayushBPreAuth?.portalData?.casePreAuthOthersResponse
            ?.casePreAuthResponse?.id
            ? ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                ?.casePreAuthResponse?.id
            : 0,
          casePreAuthIhxRequest: null,
          casePreAuthCghsRequest: null,
          casePreAuthVidalRequest: null,
          casePreAuthStarhealthRequest: null,
          casePreAuthEchsRequest: null,
          casePreAuthOthersRequest: updatedValues,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          totalAmount: "",
          claimOnPortal: true,
          action: "save",
        };
        setIsSaving(true);
        const resp = await updateDraftAyushman(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          ayushBPreAuth.portalData?.id,
          payload
        );
        successMessage("PreAuth Updated Successfully");
        setConfirmationModal(false);
        setIsSaving(false);
        if (resp) {
          dispatch(
            getPortalDataForAyushB({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
          fetchDocuments();
          await getTimelineDetail();
          await fetchStepperForStatus();
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
        }
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessageModal("Please, Fill details before submitting");
      } else {
        console.error(err);
        errorMessageModal("Please, Try again later");
      }
      setIsSaving(false);
    }
  };

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
    }
  };

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isPreAuthTabActive()) {
      // fetchStepperForStatus();
      // getTimelineDetail();
    }
  }, [
    ayushBPreAuth?.portalData,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  const handleIntimateAyushman = async () => {
    try {
      if (
        !validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        errorMessageModal("Please, Upload all required documents");
        setConfirmationModal(false);
        return;
      }

      const actionType = "intimate";
      // const values = await form.validateFields();
      const values = await form.getFieldsValue(true);

      const updatedValues = buildCasePreAuthOthersRequest(values, {
        action: actionType,
      });

      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const payload = {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          beneficiaryId: values?.beneficiaryId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
          casePreAuthId: ayushBPreAuth?.portalData?.casePreAuthOthersResponse
            ?.casePreAuthResponse?.id
            ? ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                ?.casePreAuthResponse?.id
            : 0,
          casePreAuthIhxRequest: null,
          casePreAuthCghsRequest: null,
          casePreAuthVidalRequest: null,
          casePreAuthStarhealthRequest: null,
          casePreAuthEchsRequest: null,
          casePreAuthOthersRequest: updatedValues,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          totalAmount: "",
          claimOnPortal: true,
          action: actionType,
        };
        setIsIntimating(true);
        const resp = await saveDraftAyushman(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          payload
        );
        successMessage("PreAuth Sent To QC Successfully");
        setConfirmationModal(false);
        setIsIntimating(false);
        if (resp) {
          dispatch(
            getPortalDataForAyushB({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
          fetchDocuments();
          await getTimelineDetail();
          await fetchStepperForStatus();
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
        }
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessageModal("Please, Fill details before submitting");
      } else {
        console.error(err);
        errorMessageModal("Please, Try again later");
      }
      setIsIntimating(false);
    }
  };

  const handleApprovePreAuth = async () => {
    try {
      const values = await form.validateFields();
      if (
        !validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        errorMessageModal("Please, Upload all required documents");
        setConfirmationModal(false);
        return;
      }

      const updatedValues = buildCasePreAuthOthersRequest(values);

      const payload = {
        schemeMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        beneficiaryId: values?.beneficiaryId,
        portalMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
        // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
        casePreAuthId: ayushBPreAuth?.portalData?.casePreAuthOthersResponse
          ?.casePreAuthResponse?.id
          ? ayushBPreAuth?.portalData?.casePreAuthOthersResponse
              ?.casePreAuthResponse?.id
          : 0,
        casePreAuthIhxRequest: null,
        casePreAuthCghsRequest: null,
        casePreAuthVidalRequest: null,
        casePreAuthStarhealthRequest: null,
        casePreAuthEchsRequest: null,
        casePreAuthOthersRequest: updatedValues,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        totalAmount: "",
      };

      setIsApprovedInitiated(true);
      const formData = {
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        stage: "PreAuth",
        approved: true,
        preAuthRequest: payload,
        casePreAuthId: ayushBPreAuth?.portalData?.casePreAuthOthersResponse
          ?.casePreAuthResponse?.id
          ? ayushBPreAuth?.portalData?.casePreAuthOthersResponse
              ?.casePreAuthResponse?.id
          : 0,
      };
      const res = await submitApprovalAyushman(formData);
      setIsApproved(true);
      setIsApprovedInitiated(false);
      message.success("PreAuth Approved Successfully");
      setConfirmationModal(false);
      await getTimelineDetail();
      await fetchStepperForStatus();
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        dispatch(
          getPortalDataForAyushB({
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          })
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          })
        );
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessageModal("Please, Fill details before submitting");
      } else {
        errorMessageModal("Please, Try again later");
      }
      setIsApprovedInitiated(false);
      setIsApproved(false);
    }
  };

  const handleSubmit = async () => {
    if (patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal) {
      try {
        await form.validateFields();
        setIsSubmittedOnPortal(true);
      } catch (err: any) {
        if (err?.errorFields) {
          errorMessage("Please, Fill details before submitting");
        } else {
          console.error(err);
          errorMessage("Please, Try again later");
        }
      }
    } else {
      // setManuallyClaimIdPortal(true);
      setConfirmationModal(true);
      setConfirmationState("submit");
      setTitle("Do You want to submit PreAuth ?");
    }
  };

  const handleManuallyIdEnter = () => {
    setIsSubmittedOnPortal(false);
    setIsManuallyEnteredId(true);
  };

  const handleCancelSubmissionPortal = () => {
    setIsSubmittedOnPortal(false);
    setSubmissionModal(true);
  };

  const handleCancelManuallyId = () => {
    setIsManuallyEnteredId(false);
  };

  const handleOk = () => {
    setSubmissionModal(false);
  };

  const handleRegistrationCancel = () => {
    setSubmissionModal(false);
    setIsSubmittedOnPortal(false);
  };

  const handleSaveModalOption = async () => {
    try {
      await form.validateFields();
      if (
        !validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        errorMessage("Please, Upload all required documents");
        setSubmissionModal(false);
        setIsSubmittedOnPortal(false);
        setIsSubmitting(false);
        return;
      }

      const values = await form.getFieldsValue(true);

      const updatedValues = buildCasePreAuthOthersRequest(values, {
        integratedWithPortal:
          patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
      });

      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const payload = {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          beneficiaryId: values?.beneficiaryId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse
              ?.portalMetaDataIds?.[0],
          // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
          casePreAuthId: ayushBPreAuth?.portalData?.casePreAuthOthersResponse
            ?.casePreAuthResponse?.id
            ? ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                ?.casePreAuthResponse?.id
            : 0,
          casePreAuthIhxRequest: null,
          casePreAuthCghsRequest: null,
          casePreAuthVidalRequest: null,
          casePreAuthStarhealthRequest: null,
          casePreAuthEchsRequest: null,
          casePreAuthOthersRequest: updatedValues,
          hospitalId:
            patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          totalAmount: "",
          claimOnPortal: true,
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
          action: "submit",
        };

        setIsSubmitting(true);
        const resp = await postPreAuthToPortalAyushman(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          payload
        );
        successMessage("PreAuth Submitted Successfully");
        setConfirmationModal(false);
        setIsSubmitting(false);
        setIsSubmittedOnPortal(false);
        if (resp) {
          dispatch(
            getPortalDataForAyushB({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
          fetchDocuments();
          await getTimelineDetail();
          await fetchStepperForStatus();
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
        }
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, Fill All details before submitting");
      } else if (
        typeof err?.message === "string" &&
        err.message.toLowerCase().includes("registration id not found")
      ) {
        errorMessage("Registration Id is not found");
        setIsSubmittedOnPortal(false);
        setIsSubmitting(false);
        setSubmissionModal(false);
        return;
      } else {
        console.error(err);
        errorMessage(err?.message || "Please, Try again later");
      }
      setIsLoading(false);
    }
    setSubmissionModal(false);
    setIsSubmittedOnPortal(false);
    setIsSubmitting(false);
  };

  const handleSaveManually = async (modalValues?: any) => {
    try {
      await form.validateFields();
      if (
        !validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        errorMessageModal("Please, Upload all required documents");
        setConfirmationModal(false);
        setIsManuallyEnteredId(false);
        setIsSubmitting(false);
        setManuallyClaimIdPortal(false);
        return;
      }
      const values = await form.getFieldsValue(true);

      const updatedValues = buildCasePreAuthOthersRequest(values, {
        integratedWithPortal:
          patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
      });

      if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
        const updatedData = {
          ...updatedValues,
          manualPreAuth: true,
          claimId: modalValues?.manualId || values?.manualId,
        };
        const payload = {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          beneficiaryId: values?.beneficiaryId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          // casePreAuthId: store?.preAuth?.isSaveAsDraft ? preAuthId : 0,
          casePreAuthId: ayushBPreAuth?.portalData?.casePreAuthOthersResponse
            ?.casePreAuthResponse?.id
            ? ayushBPreAuth?.portalData?.casePreAuthOthersResponse
                ?.casePreAuthResponse?.id
            : 0,
          casePreAuthIhxRequest: null,
          casePreAuthCghsRequest: null,
          casePreAuthVidalRequest: null,
          casePreAuthStarhealthRequest: null,
          casePreAuthEchsRequest: null,
          casePreAuthOthersRequest: updatedData,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          totalAmount: "",
          claimOnPortal: true,
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
          action: "submit",
        };

        setIsSubmitting(true);
        const resp = await postPreAuthToPortalAyushman(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          payload
        );
        successMessage("PreAuth Submitted Successfully");
        setConfirmationModal(false);
        setManuallyClaimIdPortal(false);
        setIsSubmitting(false);
        if (resp) {
          dispatch(
            getPortalDataForAyushB({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
          fetchDocuments();
          await getTimelineDetail();
          await fetchStepperForStatus();
          dispatch(
            getBasicDetails({
              id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
        }
      }

      setIsManuallyEnteredId(false);
      setIsSubmitting(false);
      setManuallyClaimIdPortal(false);
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, Fill details before submitting");
      } else if (
        typeof err?.message === "string" &&
        err.message.toLowerCase().includes("registration id not found")
      ) {
        errorMessage("Registration Id is not found");
        setIsSubmitting(false);
        setManuallyClaimIdPortal(false);
        setIsManuallyEnteredId(false);
        return;
      } else {
        console.error(err);
        errorMessage("Please, Try again later");
      }
      setIsSubmitting(false);
      setIsManuallyEnteredId(false);
      setManuallyClaimIdPortal(false);
    }
  };

  const handleAttachDocuments = async (updatedDocumentUrls: any) => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
    };

    const caseId = patients?.fetchBasicDetails?.casesResponse?.id;

    const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
    const schemeMetaDataId =
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

    payloadSchema["casePreAuthAttachments"] = updatedDocumentUrls;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema
        );
        message.success(`documents saved successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleSaveData = async () => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
    };

    const updatedDocumentUrls: any = documentUrls?.filter((document: any) =>
      documentRequestResponseDocuments["responseDocuments"]?.some(
        (doc: any) => doc?.label === document?.documentLabelType
      )
    );

    payloadSchema["casePreAuthAttachments"] = updatedDocumentUrls;

    const caseId = patients?.fetchBasicDetails?.casesResponse?.id;

    const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
    const schemeMetaDataId =
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema
        );
        message.success(`Response documents saved successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  return (
    <div>
      {false ? ( //isFetchingProcedure
        <Loader />
      ) : (
        <PreAuthAyushman
          form={form}
          uploadedImplantFileList={uploadedImplantFileList}
          uploadedInvestigationFileList={uploadedInvestigationFileList}
          uploadedFileColumns={uploadedFileColumns}
          handleGetData={handleGetData}
          handleModalOpen={handleModalOpen}
          uploadedImplantFileColumns={uploadedImplantFileColumns}
          handleSaveConfirmationModal={handleSaveConfirmationModal}
          handleSubmit={handleSubmit}
          isApproved={isApproved}
          isApprovedInitiated={isApprovedInitiated}
          treatmentPlansData={treatmentPlansData}
          diagnosisData={diagnosisData}
          setTreatmentPlansData={setTreatmentPlansData}
          setDiagnosisData={setDiagnosisData}
          loading={loading}
          documentRequestResponseDocuments={documentRequestResponseDocuments}
          documentTypes={documentTypes}
          documentUrls={documentUrls}
          handleFileChange={handleFileChangeNew}
          handleOpen={handleOpenNew}
          handleSaveData={handleSaveData}
          activeKey={activeKey}
          uploadFileList={uploadFileList}
          documentTypeList={documentTypeList}
          handleImplantRowUpload={handleImplantRowUpload}
          handleInvestigationRowUpload={handleInvestigationRowUpload}
          handlePreviewUploadedDoc={handlePreviewUploadedDoc}
          handleDownloadUploadedDoc={handleDownloadDocument}
          handleDeleteImplantDoc={handleDeleteImplantDoc}
          handleDeleteInvestigationDoc={handleDeleteInvestigationDoc}
          // isFetchingProcedure={isFetchingProcedure}
        />
      )}

      <PatientDetailsStageDocument
        // key={documentUrl}
        handleCancel={handleCancelPreviewNew}
        handleDeleteDocument={handleDeleteList}
        open={previewDocument}
        handleDownloadDocument={handleDownloadDocument}
        // handleSetDocumentUrl={handleSetDocumentUrl}
        documents={
          [
            ...(documentUrls || []),
            ...(uploadedInvestigationFileList || []),
          ] as any
        }
        handleDeficiencyModal={handleDeficiencyModalOpenNew}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        setDocumentName={setDocumentName}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setDocumentUrls}
        activeKey={activeKey}
        clickedActiveTab={clickedActiveTab}
        isSubmittedStatus={
          ayushBPreAuth?.portalData?.casePreAuthOthersResponse
            ?.casePreAuthResponse?.submitted
        }
        isIntimated={ayushBPreAuth?.portalData?.casePreAuthOthersResponse?.casePreAuthResponse?.intimated}
        fetchingDeficiencyData={fetchingDeficiencyData}
        clickedActiveDocumentUrl={clickedActiveDocumentUrl}
      />

      <FilePreviewModal
        isVisible={uploadFileModal}
        onClose={handleCancel}
        fileUrl={previewFile.url}
        fileName={previewFile.name}
        documentType={previewFile.documentType}
        handleUpload={handleUploadDocument}
        showUploadButton={previewFile.showUpload}
        key={
          selectedFile?.file?.uid ||
          selectedFile?.file?.name ||
          selectedFile?.file?.lastModified ||
          "no-file"
        }
        isLoading={preAuthClaim?.isLoading || enhancement?.isLoading}
      />
      <RightSidePreviewModal
        key={documentUrl}
        documentUrl={documentUrl}
        handleCancel={handleCancelPreview}
        open={previewDocumentNew}
      />
      <DocumentDeficiencyModal
        key={previewDocumentUrl}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        documentUrl={previewDocumentUrl}
        documentName={documentName}
        handleDownloadDocument={handleDownloadDocument}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={
          activeDocListType == "investigation"
            ? setUploadedInvestigationFileList
            : setUploadedImplantFileList
        }
      />

      <UploadRequestExtraDocumentAyushman
        visible={extraRequestModalOpen}
        onCancel={handleExtraRequestModalClose}
        documentMasterOptions={documentMasterOptions}
        disabled={
          ayushBPreAuth?.portalData?.casePreAuthOthersResponse
            ?.casePreAuthResponse?.submitted
        }
        onUploadAttached={handleExtraRequestUploadAttached}
      />

      {/* Implant / Investigation now use inline table & request-doc style upload */}

      <PortalSubmissionModal
        open={isSubmittedOnPortal}
        title={"Is PreAuth Already Submitted on Portal?"}
        handleCancel={handleCancelSubmissionPortal}
        handleSave={handleManuallyIdEnter}
      />

      <ManuallyIdModal
        open={isManuallyEnteredId}
        title={"Enter Claim Id"}
        handleCancel={handleCancelManuallyId}
        handleSave={handleSaveManually}
        footer={"Save"}
        isLoading={isLoading || isSubmitting}
      />

      <PortalSubmitModal
        open={submissionModal}
        title={"Do You want to Register PreAuth?"}
        handleOk={handleOk}
        handleCancel={handleRegistrationCancel}
        handleSave={handleSaveModalOption}
        isLoading={isSubmitting}
      />

      <ConfirmSubmissionModalStage
        open={confirmationModal}
        title={title}
        handleCancel={() => setConfirmationModal(false)}
        handleSave={handleSave}
        isLoading={
          isSaving || isIntimating || isApprovedInitiated || isSubmitting
        }
      />

      <ManuallyClaimIdPortal
        open={manuallyClaimIdPortal}
        title={"Enter Claim Id"}
        handleCancel={() => setManuallyClaimIdPortal(false)}
        handleSave={handleSaveManually}
        footer={"Save"}
        isLoading={isSubmitting}
      />

      {selectedFile?.file && !selectedFiles?.length && (
        <FilePreviewModal
          isVisible={previewModalVisible}
          onClose={() => setPreviewModalVisible(false)}
          fileUrl={previewFile.url}
          fileName={previewFile.name}
          documentType={previewFile.documentType}
          handleUpload={handleUpload}
          showUploadButton={previewFile.showUpload}
          key={selectedFile?.file?.lastModified || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}

      {selectedFiles?.length > 0 && (
        <MultipleFilesPreviewModal
          isVisible={previewModalVisible}
          onClose={() => {
            setPreviewModalVisible(false);
            setSelectedFiles([]);
            setUploadFileList([]);
          }}
          files={previewFiles}
          handleUpload={handleUpload}
          showUploadButton={previewFiles?.some((f) => f.showUpload)}
          key={previewFiles?.map((f) => f.name).join(",") || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}
    </div>
  );
};

export default PreAuthAyushmanContainer;
